/**
 * Created by tomers on 12/29/2016.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/audit-trail/auditTrailLayout.tmpl");
    var Button = require("ui/button/Button");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Paging = require("ui/paging/Paging");

    var AuditTrailLayout = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuditTrailLayout = Marionette.Layout.extend({
            template: template,
            className: "audit-trail-layout",
            regions: {
                tableRegion: ".table-container",
                dialogRegion: ".dialog-container"
            },
            ui: {
                viewContainer: ".view-container",
                actionMenuStrip: ".page-action-strip",
                actionMenuContainer: ".action-menu",
                doneButton: ".button-done",
                pagingContainer: ".paging-container"
            },
            uiComponents: {
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view.collection",
                        isServerHandling: true,
                        blockWrongPageNumber: true
                    },
                    events: {
                        "change:page": "_onPagingChange"
                    }
                },
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionsCollection",
                        tabindex: "1000"
                    },
                    events: {
                        "change": "_onActionSelected"
                    }
                },
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                }
            },

            initialize: function (options) {
                this.channel = LEManager.media.channel("auditTrail");
                this.collection = options.collection;
            },
            onRender: function () {
                LEManager.logger.debug("onRender AuditTrailLayout", "AuditTrailLayout:onRender");
                this.listenTo(this.collection ,"fetch:loading", this._onCollectionLoading);
                this.listenTo(this.collection ,"fetch:success fetch:error", this._onCollectionFetched);
                this.listenTo(this, "page:closeButtonClick", this._onCloseButtonClick);
            },

            _onCollectionLoading: function() {
                LEManager.showLoader();
            },

            _onCollectionFetched: function() {
                // Tomer: This need to be in defer because it's triggered before the success callback so we don't have the data on the collection if we don't defer it (as the data on the collection arrived in the success callback)
                _.defer(_.bind(function() {
                    LEManager.closeLoader();
                }, this));
            },

            _onActionSelected: function (componentId, eventName, id) {
                LEManager.logger.info("Audit trail layout: user clicked on menu action: " + id, "AuditTrailLayout:_onActionSelected");
                switch (id) {
                    case "export":
                        this._onExportClick();
                        break;
                    default:
                        break;
                }
            },

            _onExportClick: function () {
                LEManager.logger.debug("User clicked on 'export' via action menu.", "AuditTrailLayout:_onExportClick");
                this.channel.trigger("auditTrail:export");
            },

            _onPagingChange: function(componentId, eventName, currentPageNumber) {
                LEManager.logger.debug("_onPagingChange " + currentPageNumber , "AuditTrailLayout:_onPagingChange");
                this.channel.trigger("auditTrail:paging:change", currentPageNumber);
            },

            _onDoneClick: function () {
                LEManager.logger.info("User clicked on 'done' button.", "AuditTrailLayout:_onDoneClick");
                this.channel.trigger("auditTrail:page:close");
            },
            _onCloseButtonClick: function () {
                LEManager.logger.info("User clicked on 'close window' button.", "AuditTrailLayout:_onCloseButtonClick");
                this.channel.trigger("auditTrail:page:close");
            },

            _getActionsCollection: function () {
                var actionsCollection = new DropdownMenu.Collection([
                    {
                        id: "export",
                        "actionName": LE.translator.translate("LEFramework.global.captions.export"),
                        "enabled": true,
                        "title": LE.translator.translate("LEFramework.global.captions.export"),
                        "align": "right"
                    }
                ]);
                return actionsCollection;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return AuditTrailLayout;
});
